import React, { useState } from 'react';
import AlertIcon from 'ui/components/atoms/Icons/AlertIcon';
import CloseIcon from 'ui/components/atoms/Icons/CloseIcon';

function DisclaimerText({
  disclaimerText = 'Auto2000',
  backgroundColor = '#036EBC1A',
  fillIcon = '#000000',
  bgOpacity = 'bg-opacity-10',
  showIcon = true,
  closable = true,
}: {
  disclaimerText?: string;
  backgroundColor?: string;
  bgOpacity?: string;
  fillIcon?: string;
  showIcon?: boolean;
  closable?: boolean;
}) {
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  return (
    showDisclaimer && (
      <div
        className={`py-[14px] px-4 w-full bg-[${backgroundColor}] ${bgOpacity} rounded flex justify-between items-center`}
      >
        <div className="flex justify-start gap-x-3 items-center">
          {showIcon && (
            <div>
              <AlertIcon />
            </div>
          )}

          <div
            className="text-sm text-reliableBlack"
            dangerouslySetInnerHTML={{ __html: disclaimerText }}
          />
        </div>

        {closable && (
          <div className="cursor-pointer" onClick={() => setShowDisclaimer(!showDisclaimer)}>
            <CloseIcon fill={fillIcon} />
          </div>
        )}
      </div>
    )
  );
}

export default DisclaimerText;
